<template>
    <div class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="primary help-add" @click="addClick">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.add') }}
            </NevsButton>
            <NevsButton class="primary" @click="excelClick">
                <i class="fa-solid fa-file-excel"></i>
                {{ $LANG.Get('buttons.excel') }}
            </NevsButton>
            <NevsTableFilters ref="filterPanel" :summary="filterSummary" @clear="clearFilter"
                              @toggle="filtersToggled">
                <NevsTextField v-model="tableData.filters.number" :label="$LANG.Get('fields.number')"></NevsTextField>
                <NevsTextField v-model="tableData.filters.name" :label="$LANG.Get('fields.name')"></NevsTextField>
                <NevsSelect :nullable="true" v-model="tableData.filters.customer_id" :ajax="'select/customers'"
                            :label="$LANG.Get('fields.customer')"
                            @select="filterLabels.customer_id = $event.label"></NevsSelect>
                <NevsDateField v-model="tableData.filters.date_created_from"
                               :label="$LANG.Get('fields.dateCreatedFrom')"></NevsDateField>
                <NevsDateField v-model="tableData.filters.date_created_to"
                               :label="$LANG.Get('fields.dateCreatedTo')"></NevsDateField>
                <NevsDateField v-model="tableData.filters.expiration_date_from"
                               :label="$LANG.Get('fields.expirationDateFrom')"></NevsDateField>
                <NevsDateField v-model="tableData.filters.expiration_date_to"
                               :label="$LANG.Get('fields.expirationDateTo')"></NevsDateField>
            </NevsTableFilters>
        </div>
        <NevsCard>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadTable">
                <tr v-for="(item, key) in tableData.records" :key="key">
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.number }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.name }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.customer_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.date_created_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.expiration_date_display }}</td>
                    <td class="nevs-table-actions">
                        <NevsActions :width="'200px'" :actions="tableActions" :context="item"></NevsActions>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsTableFilters from "@/components/nevs/NevsTableFilters.vue";
import NevsActions from "@/components/nevs/NevsActions.vue";

export default {
    name: "ModuleContracts",
    components: {NevsTableFilters, NevsActions, NevsSelect, NevsDateField, NevsTextField, NevsTable, NevsButton, NevsCard},
    data() {
        return {
            tableData: {
                fields: [
                    {
                        name: 'number',
                        label: this.$LANG.Get('fields.number')
                    },
                    {
                        name: 'name',
                        label: this.$LANG.Get('fields.name')
                    },
                    {
                        name: 'customer',
                        label: this.$LANG.Get('fields.customer'),
                        sortable: false
                    },
                    {
                        name: 'date_created',
                        label: this.$LANG.Get('fields.dateCreated')
                    },
                    {
                        name: 'expiration_date',
                        label: this.$LANG.Get('fields.expirationDate')
                    },
                    {
                        name: 'actions',
                        width: '200px',
                        label: '',
                        sortable: false
                    }
                ],
                filters: {
                    number: '',
                    name: '',
                    customer_id: null,
                    date_created_from: null,
                    date_created_to: null,
                    expiration_date_from: null,
                    expiration_date_to: null
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                defaultSort: {
                    field: 'id',
                    descending: true
                },
                filterTimer: null,
                height: '0px'
            },
            tableActions: [
                {
                    label: this.$LANG.Get('tooltips.openInNewWindow'),
                    action: (item) => {
                        this.openClick(item.id, true);
                    },
                    visible: () => {
                        return true;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.downloadFile'),
                    action: (item) => {
                        this.downloadClick(item);
                    },
                    visible: (item) => {
                        return item.uploaded_file && item.uploaded_file.id !== 0 && item.uploaded_file.name !== '';
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.delete'),
                    action: (item) => {
                        this.deleteClick(item);
                    },
                    visible: () => {
                        return true;
                    }
                },
            ],
            // Labels of the select filters, for the collapsed filter panel's summary. v-model only
            // carries the id, so the label is captured from NevsSelect's `select` event.
            filterLabels: {
                customer_id: ''
            },
            crossTabHandle: null
        }
    },
    computed: {
        // Entries whose value is empty are dropped by NevsTableFilters, so every filter can be listed
        // here and the panel picks the active ones.
        filterSummary() {
            let filters = this.tableData.filters;
            return [
                {
                    name: 'number',
                    label: this.$LANG.Get('fields.number'),
                    value: filters.number
                },
                {
                    name: 'name',
                    label: this.$LANG.Get('fields.name'),
                    value: filters.name
                },
                {
                    name: 'customer_id',
                    label: this.$LANG.Get('fields.customer'),
                    value: filters.customer_id === null ? '' : this.filterLabels.customer_id
                },
                {
                    name: 'date_created_from',
                    label: this.$LANG.Get('fields.dateCreatedFrom'),
                    value: filters.date_created_from === null ? '' : this.$HELPERS.FormatDate(filters.date_created_from)
                },
                {
                    name: 'date_created_to',
                    label: this.$LANG.Get('fields.dateCreatedTo'),
                    value: filters.date_created_to === null ? '' : this.$HELPERS.FormatDate(filters.date_created_to)
                },
                {
                    name: 'expiration_date_from',
                    label: this.$LANG.Get('fields.expirationDateFrom'),
                    value: filters.expiration_date_from === null ? '' : this.$HELPERS.FormatDate(filters.expiration_date_from)
                },
                {
                    name: 'expiration_date_to',
                    label: this.$LANG.Get('fields.expirationDateTo'),
                    value: filters.expiration_date_to === null ? '' : this.$HELPERS.FormatDate(filters.expiration_date_to)
                }
            ];
        }
    },
    watch: {
        'tableData.filters': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadTable(vm.tableData.lastRequest);
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        downloadClick(item) {
            if (item.uploaded_file && item.uploaded_file.link) {
                window.open(item.uploaded_file.link);
            }
        },
        deleteClick(contract) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.contractDeletionQuestion'), callback: (response) => {
                    if (response) {
                        vm.$API.APICall('delete', 'contracts/' + contract.id, {}, (data, success) => {
                            if (success) {
                                vm.$CROSS_TAB_BUS.TriggerEvent('reload-contracts', {});
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        },
        // The value each filter has when it is not restricting anything.
        emptyFilters() {
            return {
                number: '',
                name: '',
                customer_id: null,
                date_created_from: null,
                date_created_to: null,
                expiration_date_from: null,
                expiration_date_to: null
            };
        },
        clearFilter(entry) {
            this.tableData.filters[entry.name] = this.emptyFilters()[entry.name];
            if (this.filterLabels[entry.name] !== undefined) {
                this.filterLabels[entry.name] = '';
            }
        },
        // Expanding the panel makes it taller, so the table gets whatever height is left over.
        filtersToggled() {
            this.$nextTick(() => {
                this.resolveWindowResize();
            });
        },
        excelClick() {
            let excelRequest = JSON.parse(JSON.stringify(this.tableData.lastRequest));
            excelRequest.rowsPerPage = 0;

            let vm = this;
            vm.$API.APICall('get', 'contracts/excel', excelRequest, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        openClick(id, newWindow = false) {
            if (newWindow) {
                let routeData = this.$router.resolve('/contracts/' + id + '/edit');
                window.open(routeData.href);
            } else {
                this.$router.push('/contracts/' + id + '/edit');
            }
        },
        addClick() {
            this.$router.push('/contracts/0/add');
        },
        reloadTable(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'contracts', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            let offset = 205;
            //the filter panel shares the button row, so only its expanded fields add height above the table
            if (this.$refs.filterPanel) {
                offset += this.$refs.filterPanel.fieldsHeight();
            }
            this.tableData.height = window.innerHeight - offset + 'px';
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-add',
                html: this.$LANG.Get('help.add'),
                left: 0,
                top: 0,
                width: 300
            },
            {
                class: 'help-edit',
                html: this.$LANG.Get('help.edit'),
                left: 0,
                top: 0,
                width: 300
            }
        ]);
        this.$store.commit('selectMenu', 'contracts');
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.contracts'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
        let vm = this;
        this.crossTabHandle = this.$CROSS_TAB_BUS.ListenToEvent('reload-contracts', () => {
            vm.reloadTable(vm.tableData.lastRequest);
        });
    },
    unmounted() {
        if (this.crossTabHandle !== null) {
            this.$CROSS_TAB_BUS.UnbindEvent(this.crossTabHandle);
        }
    }
}
</script>

<style scoped>
:deep(.nevs-table-header td) {
    padding-bottom: 10px !important;
}
</style>